import { render, staticRenderFns } from "./CSNPForm.vue?vue&type=template&id=1588012c&"
import script from "./CSNPForm.vue?vue&type=script&lang=js&"
export * from "./CSNPForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports